// import React, { useState, useRef, useCallback } from "react";
import React, { lazy, Suspense, useState, useRef, useEffect } from 'react'
import { useAuth } from "../../contexts/AuthContext";
import { login } from "../../api/auth";
import { useNavigate } from "react-router-dom";
import ScrollView from 'devextreme-react/scroll-view';
import './login.scss';
import appInfo from '../../configs/app-info';

import Form, {
    Item,
    Label,
    ButtonItem,
    ButtonOptions,
    RequiredRule,
    SimpleItem
} from 'devextreme-react/form';
import LoadIndicator from 'devextreme-react/load-indicator';
import FormHelperText from "@mui/material/FormHelperText";
import FormControl from "@mui/material/FormControl";
import { Controller, useForm } from "react-hook-form";
import TextField from "@mui/material/TextField";
import InputLabel from "@mui/material/InputLabel";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import Icon from "../../components/icon";
import FormControlLabel from "@mui/material/FormControlLabel";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import axios from "axios";
import apiUrl from "../../configs/constant";

// import ReCAPTCHA from 'react-google-recaptcha'
const ReCAPTCHA = lazy(() => import('react-google-recaptcha') as unknown as Promise<{ default: React.ComponentType<any> }>);

const usernameEditorOptions = { stylingMode: 'filled', placeholder: 'Username', mode: 'username' };
const passwordEditorOptions = { stylingMode: 'filled', placeholder: 'Password', mode: 'password' };

const Index = () => {
    const { loginUser } = useAuth();
    const navigate = useNavigate(); // Hook untuk navigasi
    const inputRef = useRef<HTMLInputElement>(null)

    const [credentials, setCredentials] = useState({ username: "", password: "" });
    const [txtErrors, setTxtError] = useState("");
    const [loading, setLoading] = useState(false);
    const [showPassword, setShowPassword] = useState<boolean>(false)
    const formData = useRef({ username: '', password: '' });
    const [recaptchaVerified, setRecaptchaVerified] = useState(false)

    const SITE_KEY = '6Ld_iSorAAAAALOjofAleah6z4LsBVlq1znxsDN5' // Ganti dengan key milikmu

    const defaultValues = {
        username: '',
        password: ''
    }

    interface FormData {
        username: string
        password: string
    }

    useEffect(() => {
        inputRef.current?.focus()
    }, [])

    const {
        control,
        setError,
        handleSubmit,
        formState: { errors }
    } = useForm({
        defaultValues,
        mode: 'onBlur',
    })

    const onSubmit = async (data: FormData) => {
        const { username, password } = data
        setLoading(true);
        // data.preventDefault();
        try {
            setTxtError("");
            const response = await login(data);

            if (response.success != false) {
                setLoading(false);
                loginUser(response);
                navigate("/");
            } else {
                setLoading(false)
                setTxtError(response.message);
            }
        } catch (error: any) {
            setLoading(false)
            setTxtError(error.message || "Login failed. Please try again.");
        }
    }

    return (
        <ScrollView height={'100%'} width={'100%'} className={'with-footer single-card'} style={{ backgroundImage: `url(${appInfo.bgLogin})` }}>
            <div className={'dx-card content'} style={{ height: '100px !important' }}>
                <div className={'header'}>
                    <center>
                        <img src={appInfo.logo} alt={appInfo.title} srcSet={appInfo.logo} width={120} />
                    </center>
                    <div className={'title'} style={{ textAlign: 'center', marginBottom: 10, marginTop: 5 }}>TAMBAQ</div>
                    <div className={'description'}>Silahkan login dengan akun anda</div>
                </div>
                <form className={'login-form'} onSubmit={handleSubmit(onSubmit)}>
                    <FormControl fullWidth sx={{ mb: 3 }}>
                        <Controller
                            name='username'
                            control={control}
                            rules={{ required: true }}
                            render={({ field: { value, onChange } }) => (
                                <TextField
                                    label='Username'
                                    autoFocus
                                    inputRef={inputRef}
                                    value={value}
                                    onChange={onChange}
                                    error={Boolean(errors.username)}
                                    placeholder='Username'
                                    size="small"
                                    variant="standard"
                                />
                            )}
                        />
                        {errors.username && (
                            <FormHelperText sx={{ color: 'error.main' }}>{errors.username.message}</FormHelperText>
                        )}
                    </FormControl>
                    <FormControl fullWidth sx={{ mb: 4 }}>
                        <Controller
                            name='password'
                            control={control}
                            rules={{ required: true }}
                            render={({ field: { value, onChange } }) => (
                                <TextField
                                    label='Password'
                                    value={value}
                                    onChange={onChange}
                                    error={Boolean(errors.password)}
                                    placeholder='Password'
                                    type="password"
                                    size="small"
                                    variant="standard"
                                />
                            )}
                        />
                        {errors.password && (
                            <FormHelperText sx={{ color: 'error.main' }} id=''>
                                {errors.password.message}
                            </FormHelperText>
                        )}
                    </FormControl>
                    <ReCAPTCHA
                        sitekey={SITE_KEY}
                        onChange={() => setRecaptchaVerified(true)}
                        onExpired={() => setRecaptchaVerified(false)}
                        size="normal"
                    />
                    <Button
                        // disabled={loading}
                        disabled={!recaptchaVerified}
                        type='submit'
                        fullWidth
                        color='primary'
                        variant='contained'
                        sx={{ mt: 2 }}
                    >
                        Login
                    </Button>
                    <FormHelperText sx={{ color: 'error.main' }}>{txtErrors}</FormHelperText>
                </form>
            </div>
        </ScrollView>
    );
};

export default Index;
